export const MOVE_MODAL_TITLE = 'move-modal-title'
export const MOVE_MODAL_DESCRIPTION = 'move-modal-description'
export const MOVE_MODAL_CANCEL = 'move-modal-cancel'
export const MOVE_MODAL_CONFIRM = 'move-modal-confirm'
